interface IFormatMoneyAmountOptions {
  currency: string;
  isBefore?: boolean;
  usesText?: boolean;
  digits?: number;
}

const defaultOptions = {
  isBefore: false,
  usesText: false,
  digits: 0,
  // currency
};

export const formatMoneyAmount = (
  num: number,
  options: IFormatMoneyAmountOptions,
) => {
  const { currency, isBefore, usesText, digits } = {
    ...defaultOptions,
    ...options,
  };
  const valueSymbolMap = [
    { value: 1e12, symbol: "T", text: "trillion" },
    { value: 1e9, symbol: "B", text: "billion" },
    { value: 1e6, symbol: "M", text: "million" },
    { value: 1e3, symbol: "K", text: "thousand" },
    { value: 1, symbol: "", text: "" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const found =
    valueSymbolMap.find((element) => Math.abs(num) >= element.value) ??
    valueSymbolMap[valueSymbolMap.length - 1];
  if (!found) throw new Error("Value symbol map is empty");

  const { value, symbol, text } = found;

  const finalValue =
    (num / value).toFixed(digits).replace(rx, "$1") +
    (usesText ? ` ${text}` : symbol);

  if (isBefore) {
    // for negative value
    if (num < 0) {
      return `- ${currency}${finalValue.slice(1)}`;
    }

    return ` ${currency}${finalValue}`;
  }

  return `${finalValue} ${currency}`;
};
